var exports = {
  "M6": "slide-aWtxc",
  "DD": "title-aWtxc",
  "MY": "page-aWtxc",
};

module.exports = exports;
